import { render, staticRenderFns } from "./InsumoForm.vue?vue&type=template&id=1271b734&"
import script from "./InsumoForm.vue?vue&type=script&lang=js&"
export * from "./InsumoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports